import moment from "moment"

import { IUsersUI } from "./types"

import { useDeviceType } from "@hooks/useDeviceType"
import CommonService from "@services/common.service"
import { ComponentsHeader } from "@primitive/sectionHeadings"

import { Button, Container, Empty, Flex, Loader, Pagination, ToolTip, Table } from "@ui/index"

import { IconDelete, IconUsers } from "@img/icons"
import imgEmty from '@img/empty.svg'
import imgAccessDenied from '@img/access_denied.svg'
import avatat from '@img/avatar_1.png'

import css from './ui.module.scss'


/** UI - Пользователи системы */
export const UsersUI = ({
    isLoadingPage, txtSearch, isAccessDenied,
    usersList, usersPageSize, usersTotalCount, paginationPageNumber,
    setTxtSearch, loadPrimaryData, handleOpenCardUser, handleOpenModalConfirm
}: IUsersUI) => {
    const deviceType = useDeviceType()

    return <div className={css['container']}>

        <ComponentsHeader
            isAccessDenied={isAccessDenied.value}
            headerIcon={<IconUsers width="20px" height="20px" />}
            headerTitle="Операторы"
            txtSearch={txtSearch}
            txtSearchTooltip={<>Поиск по:<br />🗸 Логину<br />🗸 Фамилии<br />🗸 Имени<br />🗸 Отчеству</>}
            txtSearchOnChange={(e) => setTxtSearch(e.target.value)}
            txtSearchClearOnClick={() => setTxtSearch('')}
            btnUpdateOnClick={() => loadPrimaryData(txtSearch)}
            btnCreateOnClick={() => handleOpenCardUser(true, "new")}
        />

        <Table.Container>
            <Loader isOpen={isLoadingPage} backdrop={true} title="Загрузка..." />
            <Table.Header paddingLeft="46px" paddingRight="50px" classNameContainer={css['hidden_750']} classNameContent={css['table_grid_columns_header']}>
                <div>
                    <p>Логин</p>
                    <p>Должность</p>
                </div>

                <p>Ф.И.О. оператора</p>

                <p style={{ textAlign: 'center' }}>Не<br />активен</p>
                <p className={css['hidden_1000']} style={{ textAlign: 'center' }}>Дата<br />регистрации</p>
                <p className={css['hidden_900']} style={{ textAlign: 'center' }}>Дата<br />активности</p>
            </Table.Header>

            <Table.Content>
                {usersList.length === 0
                    ? <Empty image={isAccessDenied.value === false ? imgEmty : imgAccessDenied} title={isAccessDenied.value === false ? 'Данные отсутствуют' : 'Доступ запрещён'} />
                    : usersList.map(item => {
                        const isOnline = CommonService.isOperatorOnline(item.inactiveTime)

                        return (
                            <Table.Row key={`${item.loginID}`} className={css['table_grid_columns_row']} onClick={() => handleOpenCardUser(true, "edit", item.loginID)}>
                                <div style={{ position: 'relative', width: '30px', height: '30px' }}>
                                    <img src={avatat} alt="Лого сайта" style={{ borderRadius: '100px' }} />
                                    {isOnline && <p style={{ position: 'absolute', bottom: '0px', right: '0px' }} className="pulse"></p>}
                                </div>

                                <div className={css['hidden_750']} style={{ textWrap: 'nowrap', overflow: 'hidden' }}>
                                    <p>{item.isLocked === 1 && '🔒'} {item.loginName}</p>
                                    <p style={{ opacity: '.7' }}>{item.accessLevelName}</p>
                                </div>

                                <div style={{ textWrap: 'nowrap', overflow: 'hidden' }}>
                                    <Flex gap="6px" flexDirection="row" alignItems="center">
                                        <p>{item.lastName}</p>
                                        {isOnline && <b style={{ color: '#00BB2E ' }}>(online)</b>}
                                    </Flex>

                                    <p>{`${item.firstName} ${item.secondName}`.trim()}</p>
                                </div>

                                <p style={{ textAlign: 'center' }}>{item.inactiveTime}</p>

                                <p className={css['hidden_1000']} style={{ textAlign: 'center' }}>
                                    {moment(item.dateRegistration).format('DD.MM.YYYY HH:mm:ss')}
                                </p>

                                <p className={css['hidden_900']} style={{ textAlign: 'center' }}>{
                                    item.dateLastActivity ? moment(item.dateLastActivity).format('DD.MM.YYYY HH:mm:ss') : '------'
                                }</p>

                                <Flex gap="2px" flexDirection="row" alignItems="center" justifyContent="center">
                                    <ToolTip title='Удалить' placement="bottomRight">
                                        <Button variant="icon" size={deviceType === 'mobile' ? 'xs' : 'sm'} onClick={(e) => {
                                            handleOpenModalConfirm(true, 'Удаление оператора', `Вы действительно хотите удалить оператора ${item.loginName}?`, "deleteUser", item.loginID)
                                            e.stopPropagation()
                                        }}><IconDelete width={deviceType === 'mobile' ? '16px' : '20px'} height={deviceType === 'mobile' ? '16px' : '20px'} /></Button>
                                    </ToolTip>
                                </Flex>
                            </Table.Row>
                        )
                    })
                }
            </Table.Content>
        </Table.Container>

        <Container padding="6px" className={css['footer']} overflow="visible">
            <Flex gap="4px" flexDirection="row">
                <ToolTip title='Общее количество' placement="topLeft">
                    <p className={css['stat_all']}>{usersTotalCount}</p>
                </ToolTip>
            </Flex>

            <Pagination
                totalCount={usersTotalCount}
                pageSize={usersPageSize}
                currentPage={paginationPageNumber.value}
                onChange={(e) => paginationPageNumber.setValue(e)}
            />
        </Container>
    </div>
}